export default {
  CAFETERIAS_LIST: "Liste des cafétérias",
  ADD_CAFETERIA: "Ajouter une cafétéria",
  CAFETERIA_ADDED: "Cafétéria ajoutée",
  EDIT_CAFETERIA: "Modifier une cafétéria",
  CAFETERIA_UPDATED: "Cafétéria mise à jour",
  DELETE_THIS_CAFETERIA: "Supprimer cette cafétéria ?",
  CAFETERIA_DELETED: "Cafétéria supprimée",
  SERVICE_TYPE: "Type de service",
  SERVICE_TYPE_REGULAR: "Régulier",
  SERVICE_TYPE_WITH_SERVICE: "Avec service",
  SERVICE_TYPE_WITHOUT_SERVICE: "Sans service",
  SERVICE_TYPE_ONLINE_ORDER: "Commande en ligne",
  OPERATION_TYPE: "Type d'opération",
  OPERATION_TYPE_PRODUCTION: "Cafétéria de production",
  OPERATION_TYPE_SATELLITE: "Cafétéria satellite",
  OPERATION_TYPE_AUTONOMOUS: "Cafétéria autonome",
  RELATED_PRODUCTION_CAFETERIA: "Cafétéria de production liée",
  ORDER_TYPE: "Type de commande",
  ORDER_TYPE_ONLINE: "Commande en ligne",
  ORDER_TYPE_COUNTER: "Commande au comptoir",
  SERVICE_OPTIONS: "Options de service",
  SERVICE_OPTION_BREAKFAST_ON_DEMAND: "Déjeuner sur demande",
  SERVICE_OPTION_SNACK_BAR: "Casse-croûte",
  SERVICE_OPTION_HOT_TABLE_ONE: "Table chaude (1 choix)",
  SERVICE_OPTION_HOT_TABLE_TWO: "Table chaude (2 choix)",
  SERVICE_OPTION_PANINI_ON_DEMAND: "Panini sur demande",
  SERVICE_OPTION_STIR_FRY: "Mets sautés",
  SERVICE_OPTION_PASTA_BAR: "Bar à pâtes",
  SERVICE_OPTION_READY_TO_EAT_COLD: "Prêt-à-manger froid",
  SERVICE_OPTION_READY_TO_EAT_HOT: "Prêt-à-manger chaud",
  SERVICE_OPTION_OTHER: "Autre",
  SERVICE_OPTION_OTHER_DETAIL: "Précisez l'option « Autre »",
  SERVICE_OPTION_OTHER_DETAIL_PLACEHOLDER: "Décrivez l'option de service",
  NOTE: "Note",
  NOTE_PLACEHOLDER: "Note",
  INTERNAL_ORDER_DISCOUNT: "Rabais sur les commandes internes",
  INTERNAL_ORDER_DISCOUNT_HELP:
    "Rabais appliqué automatiquement à toutes les commandes internes dont cette cafétéria de production est la source. Un pourcentage s'applique tel quel sur chaque semaine ; un montant fixe est réparti au prorata de chaque journée facturée. Laissez la valeur à zéro pour ne pas appliquer de rabais.",
  INTERNAL_ORDER_DISCOUNT_TYPE: "Type de rabais",
  INTERNAL_ORDER_DISCOUNT_TYPE_PERCENTAGE: "Pourcentage",
  INTERNAL_ORDER_DISCOUNT_TYPE_AMOUNT: "Montant fixe",
  INTERNAL_ORDER_DISCOUNT_VALUE_PERCENTAGE: "Pourcentage (%)",
  INTERNAL_ORDER_DISCOUNT_VALUE_AMOUNT: "Montant ($)",
  INTERNAL_ORDER_DISCOUNT_NAME: "Libellé",
  INTERNAL_ORDER_DISCOUNT_NAME_PLACEHOLDER: "RABAIS",
  PRODUCIBLE_PRODUCTS: "Produits productibles",
  PRODUCIBLE_PRODUCTS_EXPLANATION:
    "Liste des produits que cette cafétéria de production peut produire, choisis parmi les produits de l'entrepôt de l'établissement. Seuls ces produits seront proposés dans les commandes internes. Si la liste est vide, tous les produits de l'entrepôt sont proposés.",
  ADD_PRODUCIBLE_PRODUCTS: "Ajouter des produits",
  PRODUCIBLE_PRODUCTS_UPDATED: "Liste des produits productibles mise à jour",
  REMOVE_THIS_PRODUCIBLE_PRODUCT: "Retirer ce produit de la liste ?",
  PRODUCIBLE_PRODUCTS_EMPTY:
    "Aucun produit configuré : tous les produits de l'entrepôt de l'établissement sont proposés dans les commandes internes.",
  PRODUCIBLE_PRODUCTS_NO_WAREHOUSE:
    "L'établissement de cette cafétéria n'a pas d'entrepôt : aucune liste de produits productibles ne peut être configurée.",
};
